module.exports = __webpack_public_path__ + "img/29.9dc2156c.svg";